import React from 'react';
import { LandingComponent } from 'app/types';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const YoutubeVideoPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  return (
    <div id={landing_cmp.html_id} key={landing_cmp.id} className={`${landing_cmp.class_name} row`}>
      {landing_cmp.config.video_link && (
        <iframe
          height={'340'}
          width="100%"
          className="ua-cms__youtube-iframe"
          src={landing_cmp.config.video_link}
        ></iframe>
      )}
    </div>
  );
};

export default YoutubeVideoPreview;
